<template>
  <div class="homepage">
    <section class="slide_one section section--demo-2">
      <agile
        :speed="750"
        :timing="'linear'"
        :fade="true"
        :autoplay="true"
        :pauseOnHover="false"
      >
        <div class="slide slide--1"></div>
        <div class="slide slide--2"></div>
        <div class="slide slide--3"></div>
        <div class="slide slide--4"></div>
        <div class="slide slide--5"></div>
      </agile>
    </section>
    <!-- 公告 -->
    <!-- <section class="announcement container">
      <h1>公告</h1>
      <p>1. 春節期間自1/29～2/7，停止寄送商品服務，網站仍接受訂單</p>
      <p>2. 由於適逢金牌酬神大月，為維持品質，交貨期延長10至15天</p>
    </section> -->
    <section class="story container">
      <img src="@/images/title-2@2x.png" />
      <p>
        金牌王國金行，是 「臺灣銀樓公司」與 「鑫昌貴金屬行」(since1972)
        的關係企業，擁有自己的打金工廠與國寶級打金師傅。產品與服務包括鑄作宗教界、神像、純金法器、金龜、金牌、金佛帽...等，還有客製化道教科儀、禮贊金器。金牌是許多虔誠台灣的善男信女們作為求取事業工作、姻緣、科考、官運時作為酬神的物品，在金牌上刻上神明的稱謂、宮名並掛在神尊上或擺在供桌，非常具有意義。基於如此，金牌王國希望能夠提供快速方便的客製化金牌，也基於國際價格，公開透明的價格計算方式，確保消費者權益，讓購買金牌這件事不再需要大費周章的到銀樓耗時的等待，也能夠擁有一份客製且品質優良純金9999的金牌。
      </p>
    </section>
    <section class="culture section section--demo-2">
      <div class="slide_two">
        <agile
          @afterChange="changePhotoText"
          :speed="750"
          :timing="'linear'"
          :fade="true"
          :autoplay="true"
          :pauseOnHover="false"
        >
          <!-- <iframe width="100%" class="video-height" src="https://www.youtube.com/embed/6Y1aJlKcjUQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          <div class="slide slide--9"></div>
          <div class="slide slide--10"></div>
          <div class="slide slide--11"></div>
          <div class="slide slide--6"></div>
          <div class="slide slide--7"></div>
          <div class="slide slide--8"></div>
        </agile>
        <div v-show="isOnPhotoSlide" class="culture_des container">
          <div class="culture_title index_title" v-html="culture_title"></div>
          <p class="culture_text" v-html="culture_text"></p>
        </div>
      </div>
    </section>
    <section class="customize">
      <div class="customize_container container">
        <div class="des">
          <div class="index_title customize_title">開始客製化你的金牌</div>
          <p>
            金牌王國可以為您的的需求做任何客製，不論是外型的選擇、文字的排列、或加工的方式，不用到店裡便可以透過網頁模擬您要的效果與排版。清楚的報價機制讓您在購買前能一目了然金牌的重量、加工與所有價錢，歡迎嘗試製作屬於自己的客製金牌吧！
          </p>
          <router-link to="/gold/customize">
            <button class="btn">開始製作</button>
          </router-link>
        </div>
        <div class="pic">
          <!-- <lottie :options="defaultOptions" v-on:animCreated="handleAnimation"/> -->
          <img src="@/images/gold.gif" />
        </div>
      </div>
    </section>
    <section class="icon">
      <router-link to="/gold/service/service_quoted_price">
        <img src="@/icons/svg/card-1.svg" />
      </router-link>
      <router-link to="/gold/service/service_factory">
        <img src="@/icons/svg/card-2.svg" />
      </router-link>
      <router-link to="/gold/service/service_shop">
        <img src="@/icons/svg/card-3.svg" />
      </router-link>
      <router-link to="/gold/service/service_shipping">
        <img src="@/icons/svg/card-5-7~10.svg" />
      </router-link>
    </section>
    <section class="latest_news">
      <h2 class="latest_news_title">最新消息</h2>
      <div v-if="newsInfo.length == 0">目前無任何最新消息</div>
      <div class="news_list flex_container" v-else>
        <router-link
          class="news_item"
          to="/gold/latest_newsList"
          tag="div"
          v-for="news in newsInfo"
          :key="news.id"
          @click.native="saveId(news.id)"
        >
          <div class="news_title_container flex_container">
            <div class="news_title">{{ news.title }}</div>
            <div class="news_date">{{ news.created_at }}</div>
          </div>
          <pre class="news_content">{{ news.body }}</pre>
        </router-link>
      </div>
      <router-link class="news_btn" to="/gold/latest_newsList" tag="div">
        <button>查看全部</button>
      </router-link>
    </section>
    <section class="needmore">
      <div class="form_title index_title" id="anchor_adjustment">
        有更多黃金客製的需求嗎？
      </div>
      <p>
        除了在金牌上客製以外，金牌王國也有製造其他各式客製的產品，更多產品請參考<a
          href="https://www.instagram.com/kingdom9999.tw/"
          target="_blank"
          >金牌王國 Instagram</a
        >，如果有任何需要也可以在下面的表單做填寫，我們會盡快與您聯絡。
      </p>
      <vue-glide v-bind:breakpoints="gold_pic.breakpoints">
        <vue-glide-slide v-for="(item, index) in productImgData" :key="index">
          <img
            class="more"
            v-bind:src="item.imgURL"
            @click="lightboxControl(item.imgURL)"
            style="height: 280px; object-fit: cover"
            alt="客製化產品"
          />
          <p class="more_des">{{ item.imgName }}</p>
        </vue-glide-slide>
        <template slot="control">
          <div data-glide-dir="<">
            <div class="pre pre_next">
              <svg width="50" height="50" viewBox="0 0 50 50">
                <g fill="none" fill-rule="evenodd">
                  <path fill="#BF9F5F" d="M50 0H0v50h50z"></path>
                  <path
                    fill="#FFF"
                    fill-rule="nonzero"
                    d="M27 19l1.41 1.41L23.83 25l4.58 4.59L27 31l-6-6z"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
          <div data-glide-dir=">">
            <div class="next pre_next">
              <svg width="50" height="50" viewBox="0 0 50 50">
                <g fill="none" fill-rule="evenodd">
                  <path fill="#BF9F5F" d="M0 0h50v50H0z"></path>
                  <path
                    fill="#FFF"
                    fill-rule="nonzero"
                    d="M23 19l-1.41 1.41L26.17 25l-4.58 4.59L23 31l6-6z"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
        </template>
      </vue-glide>
      <div
        class="lightbox"
        v-bind:class="{ displaynone: closeLightbox }"
        v-body-scroll-lock="!closeLightbox"
      >
        <div class="center-container">
          <img v-bind:src="lightboxImg" />
          <div href="#" class="lightbox-close" @click="closeLightBox">
            <img src="@/images/icon-close@2x-white.png" />
          </div>
        </div>
      </div>
      <div class="form-container" id="contact_us">
        <form>
          <div>
            <input
              type="text"
              required
              placeholder="姓名"
              v-model="forGoogleData.name"
            />
          </div>
          <div>
            <input
              type="text"
              required
              placeholder="聯絡電話"
              pattern="^[0-9]{0,255}"
              oninvalid="setCustomValidity('請輸入手機號碼(純數字)')"
              v-model="forGoogleData.phone"
            />
          </div>
          <div>
            <input
              class="emailExamine"
              type="email"
              required
              placeholder="電子信箱"
              v-model="forGoogleData.mail"
            />
          </div>
          <div class="dropdown_title">
            <a href="#" v-on:click.prevent="showDropDown = !showDropDown">
              <div class="title title-color" v-if="isDataQuestion">
                {{ forGoogleData.question }}
              </div>
              <div class="title" v-else>欲詢問項目</div>
              <i
                :class="{
                  'fa-caret-up': showDropDown,
                  'fa-caret-down': !showDropDown,
                }"
                class="fa"
                aria-hidden="true"
              ></i>
            </a>
            <transition name="slide-fade">
              <div class="choice" v-if="showDropDown">
                <ul>
                  <li v-for="link in links" :key="link" class="list">
                    <span v-on:click="GoogleQquestion(link)">{{ link }}</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
          <div>
            <textarea
              placeholder="其他需求詳細說明"
              style="width: 65%; height: 50px"
              v-model="forGoogleData.other"
            ></textarea>
          </div>
        </form>
        <button class="btn" v-on:click="sendGoogleData">送出</button>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import VueAgile from "@/components/agile_plugin.vue";
import "../../scss/_agile_plugin.scss";
import { Glide, GlideSlide } from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import "../../scss/_glide_plugin.scss";

export default {
  name: "homepage",
  components: {
    agile: VueAgile,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    return {
      culture_title: "",
      culture_text: "",
      isOnPhotoSlide: false,
      isDataQuestion: false,
      closeLightbox: true,
      lightboxImg: "",
      showDropDown: false,
      links: [
        "純金佛像",
        "團體黃金飾品logo",
        "金幣銀幣",
        "神佛黃金法器",
        "特殊造型金牌",
        "自有黃金委託翻新加工",
        "黃金大宗收購",
        "客製獎牌",
        "其他",
      ],
      forGoogleData: {
        name: "",
        phone: "",
        mail: "",
        question: "",
        time: "",
        other: "",
      },
      gold_pic: {
        breakpoints: {
          1440: {
            perView: 4,
          },
          768: {
            perView: 2,
          },
          580: {
            perView: 1,
          },
        },
      },
      productImgData: [
        {
          imgURL: require("@/images/other-product/S__90480900.jpg"),
          imgName: "傳統紅字金牌",
        },
        {
          imgURL: require("@/images/other-product/S__90480901.jpg"),
          imgName: "客製金銀幣",
        },
        {
          imgURL: require("@/images/other-product/S__90480902.jpg"),
          imgName: "客製黃金獎牌",
        },
        {
          imgURL: require("@/images/other-product/S__90480903.jpg"),
          imgName: "黃金版面-大",
        },
        {
          imgURL: require("@/images/other-product/S__90480904.jpg"),
          imgName: "黃金版面-小",
        },
        {
          imgURL: require("@/images/other-product/S__8757256.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480687.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480689.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480691.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480692.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480693.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480694.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480695.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480696.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480697.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480699.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480700.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480701.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480702.jpg"),
          imgName: "",
        },
        {
          imgURL: require("@/images/other-product/S__90480703.jpg"),
          imgName: "",
        },
      ],
      newsInfo: "",
    };
  },
  created() {
    this.getNewsInfo();
  },
  methods: {
    changePhotoText(obj) {
      console.log(obj);
      if (obj.currentSlide === 0) {
        // for 影片，先隱藏
        this.isOnPhotoSlide = false;
        this.culture_title = "";
        this.culture_text = "";

        // this.culture_title = "酬神文化";
        // this.culture_text =
        // "清李斗的《揚州畫舫錄·草河錄上》上記載：「今則有借元寶之風，比紙為鈔，借一還十。主庫道士守之，酧神銷除，每歲春香火不絶，謂之財神勝會。」酧神，又稱酬神，自古以來為感謝祈求神明，衍生出了許多方式，有酬神布袋戲、歌仔戲康樂隊、做醮、三牲五禮、豬羊鮮花水果祭拜、燒金紙、自身發願茹素、當神明義工、捐贈龍柱、蓋廟等酬謝神明的行為，而其中最有意義的是：製作一份雋有自己的名份的金牌掛在神尊，或擺在供桌上。而現代人也常常向神明祈求事業、工作、考試、姻緣順遂，還願時較為虔誠的信徒們會製作金牌加以答謝，可以說是台灣民間最常見的習俗文化與活動。";
      }
      if (obj.currentSlide === 5) {
        this.isOnPhotoSlide = true;
        this.culture_title = "關於金牌王國";
        this.culture_text =
          "金牌王國擁有45年多樣化黃金製程與各式商品的製作與設計經驗，現在您不用來店裡就可以直接在網站上製作，官網中可以直接點選客制功能，進行客製。";
      }
    },
    GoogleQquestion(question) {
      this.showDropDown = !this.showDropDown;
      this.forGoogleData.question = question;
      this.isDataQuestion = true;
    },
    sendGoogleData() {
      var status = true;
      //如果需要驗證放這邊，沒有過的改status爲false

      if (status) {
        var currentdate = new Date();
        var filltime =
          currentdate.getFullYear() +
          "/" +
          (currentdate.getMonth() + 1) +
          "/" +
          currentdate.getDate() +
          "  " +
          currentdate.getHours() +
          ":" +
          currentdate.getMinutes() +
          ":" +
          currentdate.getSeconds();
        this.forGoogleData.time = filltime;
        let checkResult = this.examineData();
        if (checkResult == "ok") {
          this.sendGoogleSheet();
        }
      }
    },
    sendGoogleSheet() {
      axios({
        url: "https://script.google.com/macros/s/AKfycbwdp8shh28sbX9PShnpx3wn80f37i8MyMWAa-8YAaiT4zmhuCw/exec",
        method: "get",
        params: this.forGoogleData,
      })
        .then(() => {
          alert("感謝您的填寫，專人會儘速爲您服務唷");
          this.forGoogleData.name = "";
          this.forGoogleData.phone = "";
          this.forGoogleData.mail = "";
          this.forGoogleData.question = "";
          this.isDataQuestion = false;
          this.forGoogleData.other = "";
          this.forGoogleData.time = "";
        })
        .catch((e) => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    lightboxControl(url) {
      this.closeLightbox = !this.closeLightbox;
      this.lightboxImg = url;
    },
    examineData() {
      let allInput = document.querySelectorAll("input");
      let email = document.querySelector(".emailExamine");
      allInput.forEach((item) => {
        item.style.border = "1px solid #a8894c";
      });
      email.style.border = "1px solid #a8894c";
      let errorData = document.querySelectorAll("input:invalid");
      //email驗證格式
      let emailExamine = /^.*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if (errorData.length !== 0 || this.forGoogleData.question == "") {
        alert("尚有聯絡資料未填寫或格式錯誤");
        errorData.forEach((item) => {
          item.style.border = "2px solid red";
        });
        return "error";
      } else if (!emailExamine.test(this.forGoogleData.mail)) {
        email.style.border = "2px solid red";
        return "error";
      } else {
        return "ok";
      }
    },
    closeLightBox() {
      this.closeLightbox = !this.closeLightbox;
    },
    getNewsInfo() {
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/news",
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          this.newsInfo = response.data.data;
        })
        .catch((e) => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    saveId(id) {
      this.$store.dispatch("setViewNewsId", id);
    },
  },
};
</script>

<style scoped lang="scss">
.homepage {
  padding-top: 80px;
}
.container {
  width: 80%;
  margin: 50px auto;
}
button {
  @extend %button;
}
p {
  font-size: 17px;
  letter-spacing: 1px;
  line-height: 30px;
  margin: 0;
  color: $secondaryDeepColor1;
}
.index_title {
  font-size: 35px;
  letter-spacing: 2px;
  color: #a8894c;
  text-align: left;
  font-family: "NotoSerifTC-Bold";
  @include desktop {
    text-align: center;
    margin-bottom: 20px;
  }
}
.story {
  img {
    width: 150px;
    margin-bottom: 40px;
  }
  p {
    text-align: center;
  }
}
.slide_two {
  position: relative;
}
.culture_des {
  position: absolute;
  top: 50%;
  transform: translate(0, -68%);
  right: 10%;
  width: 486px;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1;
  padding: 30px 40px 40px 40px;
  @include desktop {
    position: unset;
    background-color: transparent;
    width: 80%;
    height: auto;
    padding: 0;
    margin: 30px auto;
    transform: translate(0, 0);
  }
  p {
    text-align: left;
    line-height: 28px;
  }
}

.customize {
  background-color: $secondaryColor3;
  padding: 50px 0 30px 0;
  .customize_container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
    width: 80%;
    align-items: center;
    @include tablePro {
      grid-template-columns: 1fr;
    }
  }
  .customize_title {
    padding: 0;
    margin-bottom: 30px;
    @include tablePro {
      text-align: center;
      margin-bottom: 30px;
    }
  }
  p {
    text-align: left;
  }
  button {
    margin-top: 30px;
    margin-bottom: 30px;
    float: left;
    @include tablePro {
      float: none;
    }
  }
  &::after {
    clear: both;
  }
  .des {
    margin-top: 30px;
    @include tablePro {
      margin: 0;
      order: 2;
    }
  }
  .pic {
    width: 100%;
    margin-left: auto;
    img {
      width: 90%;
      padding-left: 30px;
      @include tablePro {
        width: 80%;
        margin: 0;
        padding-left: 0;
      }
    }
  }
}

.icon {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  @include betweenTableTablePro {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }
  img {
    @include betweenPhoneTable {
      width: 150px;
    }
  }
}

.latest_news {
  width: 80%;
  margin: auto;
  font-size: 17px;
  color: $secondaryDeepColor1;
  text-align: left;
  .latest_news_title {
    text-align: center;
    color: $primaryDeepColor;
    font-size: 30px;
    font-family: "NotoSerifTC-Bold";
  }
  // .news_list {
  //   @include betweenPhoneTable {
  //     height: 600px;
  //     overflow: scroll;
  //   }
  // }
  .flex_container {
    display: flex;
  }
  .news_list.flex_container {
    flex-wrap: wrap;
  }
  .news_item {
    box-sizing: border-box;
    width: 32%;
    margin-right: 2%;
    margin-bottom: 2%;
    border: 1px solid $primaryDeepColor;
    padding: 16px;
    cursor: pointer;
    &:hover {
      background-color: $secondaryColor3;
    }
    @include betweenDesktopTablePro {
      width: 48%;
    }
    @include betweenTableTablePro {
      width: 100%;
    }
    @include betweenTableTablePro {
      margin-right: 0;
    }
  }
  .news_item:nth-child(2n) {
    @include betweenDesktopTablePro {
      margin-right: 0;
    }
  }
  .news_item:nth-child(3n) {
    margin-right: 0;
    @include betweenDesktopTablePro {
      margin-right: 2%;
    }
    @include betweenTableTablePro {
      margin-right: 0;
    }
  }
  .news_title_container.flex_container {
    margin-bottom: 16px;
    justify-content: space-between;
  }
  .news_title {
    width: 70%;
    font-weight: 600;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    @include phone {
      width: 65%;
    }
  }
  .news_date {
    flex: 0 0 auto;
  }
  .news_content {
    white-space: pre-wrap;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .news_btn {
    text-align: center;
    padding: 30px 0 50px 0;
  }
}

//more gold
.needmore {
  background: url(../../images/form-bg.png);
  .form_title {
    text-align: center;
    color: $secondaryDeepColor1;
    padding: 50px 50px 10px 50px;
    font-size: 30px;
  }
  svg {
    &:hover path:first-of-type {
      fill: $primaryDeepColor;
      transition: all ease 0.3s;
    }
  }
  form {
    width: 750px;
    margin: 0 auto;
    @include betweenTableTablePro {
      width: 100%;
    }
  }
  .form-container {
    margin: 0 auto;
    font-size: 17px;
    width: 80%;
    @include phone {
      width: 100%;
    }
  }
  .form- {
    margin-top: 15px;
    margin-bottom: 8px;
  }
  input {
    width: 65%;
    padding: 16px;
    font-size: 17px;
    border: 1px solid $primaryDeepColor;
    margin-bottom: 20px;
  }
  input::placeholder {
    color: #9b9b9b;
  }
  .pre_next {
    position: absolute;
    top: 120px;
    @include betweenDesktopTablePro {
      top: 100px;
    }
    @include betweenTableTablePro {
      top: 80px;
    }
    @include table {
      top: 140px;
    }
    @include betweenPhoneTable {
      top: 170px;
    }
    @include phone {
      top: 135px;
    }
  }
  .pre {
    left: -80px;
    @include betweenPhoneTable {
      left: -47px;
    }
  }
  .next {
    right: -80px;
    @include betweenPhoneTable {
      right: -47px;
    }
  }
  .more {
    width: 100%;
  }
  p {
    text-align: center;
    width: 80%;
    margin: auto;
  }
  button {
    margin-top: 14px;
    margin-bottom: 50px;
  }
  a {
    color: $primaryDeepColor;
  }
}
.lightbox {
  position: fixed;
  top: 0;
  z-index: 1111111;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .center-container {
    flex: 0 0 60vmin;
    @include betweenPhoneTable {
      flex: 0 0 90vmin;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .lightbox-close {
    box-sizing: border-box;
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.displaynone {
  display: none;
}
textarea {
  font-size: 17px;
  padding: 15px;
  border: 1px solid $primaryDeepColor;
  resize: none;
}
textarea::placeholder {
  color: #9b9b9b;
  font-size: 17px;
}
//dropdown
.menu {
  background-color: $secondaryColor3;
}

.list a,
.list span {
  &:hover,
  &:focus {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
}

.dropdown_title {
  position: relative;
  width: 69%;
  margin: 0 auto;
  margin-bottom: 20px;
  @include phone {
    width: 100%;
  }
  @include betweenPhoneTable {
    width: 100%;
  }
  @include table {
    width: 100%;
  }
  @include tablePro {
    width: 100%;
  }
  p {
    text-align: left;
    @include phone {
      text-align: center;
    }
    @include betweenPhoneTable {
      text-align: center;
    }
    @include table {
      text-align: center;
    }
    @include tablePro {
      text-align: center;
    }
  }
  a,
  span {
    color: $secondaryLightColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 15px;
    border: 1px $primaryDeepColor solid;
    margin-top: -1px;
    background-color: $secondaryColor3;
    @include tablePro {
      width: 65%;
      margin: -1px auto 0 auto;
    }
  }
  .title-color {
    color: $secondaryDeepColor1;
  }
}

ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin: auto;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 1;
  span {
    color: $secondaryDeepColor1;
  }
}
.fa {
  margin-left: auto;
  color: $primaryDeepColor;
}

// video height
.video-height {
  height: 500px;
  @include tablePro {
    height: 400px;
  }
  @include table {
    height: 300px;
  }
  @include phone {
    height: 200px;
  }
}

//公告
.announcement {
  h1 {
    color: #ae2e2d;
  }
  p {
    font-weight: 800;
    font-size: 20px;
  }
}
</style>
